import React from "react";
import "./CollaboratorDialog.css";
import {
    CollaboratorList,
} from "../../models/Collaboration/CollaboratorList";
import {useUserInfo} from "../../hooks/useUserInfo";
import {debug_log, is_dev} from "../../utils/debug";
import {DropMenu} from "../JourneyMapEditor/DropMenu";
import {useTranslation} from "react-i18next";
import {listMapCollaborators} from "../../graphql/Collaborator";

type NonOwnerCollaboratorDialogProps = {
    mapId: string;
    show: boolean;
    onClose: (revoke:boolean) => void;
}

export const NonOwnerCollaboratorDialog = (props: NonOwnerCollaboratorDialogProps) => {

    const {t} = useTranslation();
    const {userName, userEmail} = useUserInfo();

    const ref = React.useRef<HTMLDialogElement>(null);
    const [collaborator_list, setCollaboratorList] = React.useState<CollaboratorList>(CollaboratorList.createEmpty());

    React.useEffect(() => {
        if (ref.current === null) {
            return;
        }

        if (props.show) {
            !ref.current.open && ref.current.showModal();
        } else {
            ref.current.open && ref.current.close();
        }
    }, [props.show]);

    React.useEffect(() => {
        if (!userName || !userEmail) {
            return;
        }

        const created_collaborator_list = CollaboratorList.createEmpty();
        setCollaboratorList(created_collaborator_list);

        listMapCollaborators(props.mapId)
            .then(collaborators => {
                if (0 < collaborators.length) {
                    setCollaboratorList(created_collaborator_list.mergeArray(collaborators));
                }
            })
            .catch((res) => {
                debug_log(res);
            });

    }, [props.mapId, userEmail, userName]);

    return (
        <dialog ref={ref} className="collaborator-dialog-dialog" onCancel={() => props.onClose(false)}>
            <div className="collaborator-dialog" onClick={e => e.stopPropagation()}>
                <h2 className="collaborator-dialog-title-area">{t("共有ユーザ設定")}</h2>
                <span className="collaborator-dialog-close-button" onClick={() => props.onClose(false)}/>

                <div className="collaborator-dialog-description-area">
                    <ul>
                        <li>{t("マップの削除、共有ユーザの追加や権限の変更はオーナーのみが行えます")}</li>
                        <li>{t("オーナーからあなたに共有されたマップの共有を拒否する場合は『「アクセス権」削除』を選択してください")}</li>
                    </ul>
                </div>

                <div className="collaborator-dialog-listing-area">
                    <ul className="collaborator-dialog-listing particular_collaborator-dialog-listing">
                        {collaborator_list.list(c =>
                            <li key={c.User}>
                                <div>
                                    <span title={is_dev() ? c.User : undefined}>{c.Email}</span>
                                    {c.User === userName && <span className="is_you">{t("あなた")}</span>}
                                </div>
                                <div>
                                    {c.User === userName
                                        ? <DropMenu containerClassName="collaborator-change-type"
                                                    label={t(c.TypeLabel)}
                                                    onChange={menu_name => menu_name === "deleted" && props.onClose(true)}>
                                            <ul className="collaborator-dialog-dropdown-menu">
                                                <li data-drop_menu="">{t(c.TypeLabel)}</li>
                                                <li data-drop_menu='deleted'>{t("アクセス権を削除")}</li>
                                            </ul>
                                        </DropMenu>
                                        : <span>{t(c.TypeLabel)}</span>
                                    }
                                </div>
                            </li>
                        )}
                    </ul>

                </div>
            </div>
        </dialog>
    );
}
